import { useLanguage } from "../i18n/LanguageContext";
import { INSTAGRAM_URL } from "../constants";
import logo from "../assets/raiz-logo.svg";
import "./Footer.css";

function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="Footer">
      <div className="Footer-inner">
        <img src={logo} alt="" className="Footer-logo" />
        <p className="Footer-tagline">{t("footer.tagline")}</p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="Footer-instagram"
        >
          @raiz.mandioca
        </a>
        <p className="Footer-rights">
          © {year} Raiz. {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
